import { atom } from 'recoil';

import { StoreOrderInCart } from '~/types/cart';

const orders = atom<Array<StoreOrderInCart>>({
  key: 'orders',
  default: [],
});

export default orders;
